import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ROUTE_PATHS } from '@/lib/index';
import { selectionMatrixData } from '@/data/index';
import { MatrixRow } from '@/components/Cards';

export default function Selection() {
  const quickSelectTips = [
    { label: '耐化学介质', code: 'FKM', description: '强酸碱环境首选' },
    { label: '耐候户外', code: 'EPDM', description: '抗UV老化' },
    { label: '耐油液压', code: 'NBR', description: '石油基介质' },
    { label: '高弹耐磨', code: 'NR', description: '矿山输送' }
  ];

  return (
    <div className="min-h-screen bg-background">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="container mx-auto px-4 py-16"
      >
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-0.5 bg-primary"></div>
              <span className="font-mono text-xs font-bold tracking-widest uppercase text-primary">
                SELECTION MATRIX
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              选型参数矩阵
            </h1>
            <p className="text-lg text-muted-foreground max-w-3xl">
              根据应用环境、温度范围和机械性能要求，快速找到最适合的橡胶板型号。所有技术数据均依据ISO/ASTM国际标准测试得出。
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-card border border-border rounded-lg overflow-hidden mb-12"
          >
            <div className="overflow-x-auto">
              <table className="w-full table-industrial">
                <thead>
                  <tr>
                    <th className="px-6 py-4 text-left">产品名称</th>
                    <th className="px-6 py-4 text-center">产品代号</th>
                    <th className="px-6 py-4 text-center">温度范围</th>
                    <th className="px-6 py-4 text-center">拉伸强度(MPa)</th>
                    <th className="px-6 py-4 text-center">断裂伸长率(%)</th>
                    <th className="px-6 py-4 text-center">硬度(Shore A)</th>
                    <th className="px-6 py-4 text-center">核心特性</th>
                  </tr>
                </thead>
                <tbody>
                  {selectionMatrixData.map((row, index) => (
                    <MatrixRow key={row.id} row={row} index={index} />
                  ))}
                </tbody>
              </table>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="mb-12"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-0.5 bg-primary"></div>
              <span className="font-mono text-xs font-bold tracking-widest uppercase text-primary">
                QUICK SELECT
              </span>
            </div>
            <h2 className="text-2xl font-bold mb-6">快速选型指南</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {quickSelectTips.map((tip, index) => (
                <motion.div
                  key={tip.code}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.5 + index * 0.1 }}
                  className="card-industrial p-6"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <span className="badge-code">{tip.code}</span>
                  </div>
                  <h3 className="text-lg font-bold mb-2">{tip.label}</h3>
                  <p className="text-sm text-muted-foreground">{tip.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
            className="flex flex-wrap gap-4 justify-center"
          >
            <Link to={ROUTE_PATHS.CONTACT}>
              <button className="btn-primary-industrial px-8 py-3 rounded-md">
                联系技术团队
              </button>
            </Link>
            <Link to={ROUTE_PATHS.PRODUCTS}>
              <button className="btn-outline-industrial px-8 py-3 rounded-md">
                查看产品系列
              </button>
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}